import { genericEmbeddedTypeDecode, neverEmbeddedTypeDecode } from "./reader.js";
import { genericEmbeddedTypeEncode, neverEmbeddedTypeEncode } from "./writer.js";
import type { GenericEmbedded, EmbeddedType } from "./embedded.js";

export const genericEmbeddedType: EmbeddedType<GenericEmbedded> =
    Object.assign({},
                  genericEmbeddedTypeDecode,
                  genericEmbeddedTypeEncode);

export const neverEmbeddedType: EmbeddedType<never> =
    Object.assign({},
                  neverEmbeddedTypeDecode,
                  neverEmbeddedTypeEncode);
